import { Rgb } from '@optimization/ssi-common';
import { RouteType } from '../services/solution/types/common';

export const APP_TITLE: string = import.meta.env.VITE_APP_TITLE;
export const APP_USP: string = import.meta.env.VITE_APP_USP;

export const MULTIPLE_VALUES_SEPARATOR = ',';

export const SUPPORT_NAME = 'E-Mobility sales tools';
export const SUPPORT_EMAIL = 'emobilitysalestools@scania.com';

export const MODE: string = import.meta.env.MODE;
export const DAILY_ODOMETER_PERCENTILES_ENABLED: boolean =
  import.meta.env.VITE_DAILY_ODOMETER_PERCENTILES_ENABLED === 'true';
export const MOCKING_ENABLED = import.meta.env.VITE_MOCKING_ENABLED === 'true';
export const THEME_COLOR: string = import.meta.env.VITE_THEME_COLOR;
export const IMPORT_CUSTOMER_ENABLED = import.meta.env.VITE_IMPORT_CUSTOMER_ENABLED === 'true';

export const SOLUTION_ENDPOINT: string = import.meta.env.VITE_SOLUTION_ENDPOINT;
export const POLYLINE_ARTIFACT_ORIGIN: string = import.meta.env.VITE_POLYLINE_ARTIFACT_ORIGIN;
export const ROUTER_API = 'https://router.hereapi.com';
export const REVERSE_GEOCODE_ENDPOINT = 'https://revgeocode.search.hereapi.com';
export const MULTIPLE_REVERSE_GEOCODE_ENDPOINT = 'https://multi-revgeocode.search.hereapi.com';
export const AUTOCOMPLETE_ENDPOINT = 'https://autocomplete.search.hereapi.com';
export const LOOKUP_ENDPOINT = 'https://lookup.search.hereapi.com';
export const HERE_MAPS_API_KEY = 'OcOv22pL0eb89DYyu3mAEhRtmzq2RMqAmOLnTWPsEUw';

export const MAP_ORIGIN_LATITUDE = 17.570_692;
export const MAP_ORIGIN_LONGITUDE = -3.996_166;

// HERE Maps responses are English-only until the app supports additional languages.
export const USER_LANGUAGE = 'en';
export const BEV_RANGE_COLOR: Rgb = { r: 74, g: 137, b: 243 };
export const UNMET_DISTANCE_COLOR: Rgb = { r: 32, g: 88, b: 168 };
export const TYPICAL_DISTANCE_COLOR: Rgb = { r: 255, g: 255, b: 255 };
export const LONGEST_DISTANCE_COLOR: Rgb = { r: 241, g: 194, b: 27 };
export const DAILY_ODOMETER_75_COLOR: Rgb = { r: 255, g: 0, b: 168 };
export const DAILY_ODOMETER_95_COLOR: Rgb = { r: 0, g: 230, b: 118 };

export const NO_DEPOT_NAME = 'No depot';

export const ROWS_PER_PAGE_DEFAULT = 10;
export const MAX_BATTERY_LIFE_YEARS = 15;
export const DEFAULT_BATTERY_LIFE = MAX_BATTERY_LIFE_YEARS;

export const POWER_NEED_COLORS = {
  chargingPowerBelowMaxCapacity: '#6191B4',
  chargingPowerAboveMaxCapacity: '#B46161',
  maxCapacity: '#F1C21B',
  futureMaxCapacity: '#868FA2',
};

export const CHARGING_SCHEDULE_COLORS = {
  charging: '#6191b4',
  driving: '#E0CFAD',
  stops: '#B0B7C4',
};

export const WINTER_TEMPERATURE = -5;
export const MEDIAN_TEMPERATURE = 10;
export const SUMMER_TEMPERATURE = 25;

export const NO_VALUE_PLACEHOLDER = '...';

export const MISSING_IMPORTED_CHASSIS_SIGN = '??';

export const MEDIAN_STOP_TIME_GROUPS: Record<string, { backgroundColor: string }> = {
  '0': { backgroundColor: '#AE8EB8' },
  '1': { backgroundColor: '#A682B0' },
  '2': { backgroundColor: '#9D75A9' },
  '4': { backgroundColor: '#9468A1' },
  '8': { backgroundColor: '#895E97' },
  '12': { backgroundColor: '#7E568A' },
};

export const CHASSIS_HEIGHT_LABELS: Record<string, string> = {
  E: 'Extra Low',
  L: 'Low',
  N: 'Normal',
  H: 'High',
  S: 'Super High',
};

export const CHASSIS_ADAPTATION_LABELS: Record<string, string> = {
  A: 'Articulated',
  B: 'Basic',
};

export const ROUTE_TYPE_LABELS: Record<RouteType, string> = {
  Urban: 'Urban',
  LongHaulage: 'Long Haulage',
};
